var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.001,
    height: 464.126,
    viewBox: "0 0 800.001 464.126",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-560 -308)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(301.504 -98.038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.83,820.941l104.326-79.952,414.371-9.429,72.338,103.779H93.83Z",
    transform: "translate(164.666 33.556)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.036,844.368v2.766a5.393,5.393,0,0,1-5.393,5.393H386.159c-2.982,0,0-5.955,0-5.955l-1.78-39a6.439,6.439,0,0,1,4.857-6.534c8.764-2.212,14.8,1.34,14.8,1.34l97.557-2.48a31.277,31.277,0,0,1,6.05.285,26.5,26.5,0,0,1,17.881,10.6l22.419,30.4a5.393,5.393,0,0,1,1.1,3.2Z",
    transform: "translate(264.248 3.457)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.88,783.55H369.36l3.248,42.928,136.124-2.84Z",
    transform: "translate(289.136 24.59)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(351.998 406.038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.907,837.661v13.963l-138.577,5.622s-31.686-2.163-35.573-21.633a18.162,18.162,0,0,1,.116-6.131c1.4-8.2,8.433-22.523,39.436-29.141l38.175-3.922h85.12S352.6,807.422,352.907,837.661Z",
    transform: "translate(-178.552 -417.499)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,853.923l22.419,11.083,23.854-5.645.116-38.881c-1.515-28.377,11.568-85.178,18.035-110.917q3.737-14.923,6.536-30.078l7.334-39.506L261.233,537.32H232.821l-16.7,23.923Z",
    transform: "translate(-149.66 -456.68)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.742,785.07l-76.085,80.215-8.954.636L192.524,500.361A34.879,34.879,0,0,1,189.32,487l113.092,15.178c5.352.719,14.136,3.009,15.778,8.154l77.544,257.282a17.584,17.584,0,0,1-3.991,17.457Z",
    transform: "translate(-176.864 -487)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.987,779.231a17.6,17.6,0,0,1-3.181,3.965l-77.433,72.338L203.73,503.71,305.176,513.8a17.8,17.8,0,0,1,15.3,12.653L391.733,764.9A18.015,18.015,0,0,1,389.987,779.231Z",
    transform: "translate(-178.134 -491.293)",
    fill: "#f59e0b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M534.138,783.226a88.006,88.006,0,0,1-9.351,4.261c-8.349,3.284-21.07,7.052-32.919,5.609-19.921-2.42-31.839,4.1-31.839,4.1l-4.468-33.144s14.692-4.321,20.664-5.4c4.477-.864,20.63-8.305,28.382-11.961,2.593-1.21,4.209-2.005,4.209-2.005h14.9Z",
    transform: "translate(254.585 10.947)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.322,673.257v72.6l-3.9,4.615-12.488,14.779-48.222,11.94c1.124-53.255-24.13-39.205-24.13-39.205,19.921-21.416,30.254-17.615,30.254-17.615,16.766-27.267,43.411-51.821,45.123-54.439C584.326,663.819,585.329,661.9,596.322,673.257Z",
    transform: "translate(247.523 21.856)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.186,562.706S725.891,573.2,715.9,586.568c-23.248,31.113-61.068,77.783-55.312,43.921.19-1.106.337-2.213.467-3.327-1.417.951-4.667.121-8.21-1.564l-.242-.112a42.251,42.251,0,0,1-5.047-2.921c-.182-.112-.354-.233-.527-.354-3.932-2.74-7.078-5.946-6.914-8.158,2.792-48.606,14.1-25.426,17.285-20.033a3.511,3.511,0,0,0,.726,1.011q-.207-.57-.467-1.193A237.181,237.181,0,0,0,646.3,571.452v-.086l-.648-1.158c-4.045-7.216-8.426-14.761-12.367-21.382l-1.063-1.78C626,536.605,646.3,527.488,646.3,527.488s3.129-24.528,26.956-40.24c19.878-13.128,36.713-19.186,31.329,2.835-3.457,14.156-2.446,26.265.743,36.3.112.372.233.743.363,1.106a58.6,58.6,0,0,0,2.213,5.626,63.9,63.9,0,0,0,3.872,7.346A71.206,71.206,0,0,0,733.186,562.706Z",
    transform: "translate(230.764 47.494)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.7,464.915a73.047,73.047,0,1,1-21.393-51.98,73.375,73.375,0,0,1,21.393,51.98Z",
    transform: "translate(239.057 65.543)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.9,608.667c-2.333-5.73-6.914-14.433-12.039-23.629l.648-.328,11.857,23.663a2.524,2.524,0,0,0-.467.294Z",
    transform: "translate(228.48 32.663)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.319,655.883c6.6,24.6-6.154,91.526-6.154,91.526l-9.31,82.674H621.9s2.973-24.2,2.973-27.933-3.345-9.308-2.973-13.4,1.8-1.124,0-8.193-2.593-26.446-8.53-33.144-15.669-31.295-12.7-52.114-4.848-48.787-4.848-48.787,11.918-35.754,16.015-38.364,23.076-24.951,23.076-24.951l6.516-3.258h.536l11.629,22.649s16.005-5.9,15.625-8l2.693-8.375,34.9-35.7h.043l.683-.458h-.069c-.311,0-1.21-.553-2.93-4.6-.441-1.028-.933-2.273-1.478-3.811,0,0,14.226-5.713,19.3-1.53a4.522,4.522,0,0,1,.864.916,3.619,3.619,0,0,1,.372.614c3.353,6.914,4.84,12.1,8.193,16.576a14.406,14.406,0,0,0,1.175,1.357c4.053,4.243,47.942,38.782,47.942,38.782S795.716,631.286,802.319,655.883Z",
    transform: "translate(235.548 38.925)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.381,767.181s-47.37-13.707-50.723,7.337,19.368,33.144,33.887,32.772S459.4,793.134,459.4,793.134Z",
    transform: "translate(261.54 8.488)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.4,838.6s-10.613,7.631-33.144,7.631-48.787,4.84-48.787,4.84S593.954,772.12,526.733,839.7c0,0-12.1,15.643,50.645,17.285,0,0,22.159-.743,27,10.241H729.694L746.832,854.4Z",
    transform: "translate(245.05 1.761)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.183,729.508s-4.605-10.833-10.066,0l-2.957,84.051,6.493,19.792,6.493-17.615Z",
    transform: "translate(255.179 -20.364)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.037,541.056c-6.5,2.212-13.629,7.4-15.729,9.023-.389,0-1.729-.864-4.408-8.409C719.891,541.669,735.975,535.213,740.037,541.056Z",
    transform: "translate(218.701 38.921)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.618,608.662s-43.947,34.077-36.869,69.46,29.041,63.408,36.869,92.318-5.557,23.319-32.746,39.144l30.353,29.981s46.5,4.586,67.308-4.726,15.911-32.523,15.911-32.523L837.2,760.788,808.52,650.553S809.263,603.261,758.618,608.662Z",
    transform: "translate(218.553 29.47)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.174,
    cy: 7.744,
    rx: 14.174,
    ry: 7.744,
    transform: "translate(691.339 778.045)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.222,205.057s-2.137,28.642-32.372,29.451c-40.888,1.093-59.83,3.289-59.83,3.289S837.238,106.09,815.92,120.3s-78.168-45.377-78.168-45.377l-16.774,31.46S680.9,91.875,725.316,56.339c0,0,52.992-40.969,109.249-16.367S880.222,205.057,880.222,205.057Z",
    transform: "translate(95.091 405.774)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0A4,4,0,0,1,8,4c0,2.949-3.259,4.66-3.312,7.3C4.341,28.685,5.951,31,4,31a4,4,0,0,1-4-4l4.314-4.982L0,4A4,4,0,0,1,4,0Z",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 671.958, 813.187)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.688,11.3c-.347,17.389,5.875,20.166,3.924,20.166-2.209,0-8.612-2.253-4.3-9.444L0,4C0,3.315,4.725,9.477,4.688,11.3Z",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 689.957, 812.726)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.a2f9cd006aca36daa8655eba6bdbda97.svg";
export { ForwardRef as ReactComponent };